export default "__VITE_ASSET__0016a413__"